module.exports = __webpack_public_path__ + "static/media/interlocutor.7dc5b269.webp";